'use client';

import {
  FaFacebookSquare,
  FaPinterestSquare,
  FaTwitterSquare,
} from 'react-icons/fa';
import {
  FacebookShareButton,
  // FacebookIcon,
  PinterestShareButton,
  // PinterestIcon,
  TwitterShareButton,
  // TwitterIcon,
} from 'react-share';

interface SocialShareProps {
  url: string;
  title?: string;
  media?: string;
  description?: string;
  showPinterest?: boolean;
}

const SocialShare = ({
  url,
  media,
  description,
  title,
  showPinterest = true,
}: SocialShareProps) => {
  // const facebookBgStyle = { fill: '#cad808' }; // Facebook blue
  // const twitterBgStyle = { fill: '#cad808' }; // Twitter blue
  // const pinterestBgStyle = { fill: '#cad808' }; // Pinterest red

  return (
    <>
      <TwitterShareButton url={url} title={title} aria-label="Share on Twitter">
        <FaTwitterSquare size={32} aria-hidden="true" />
        {/* <TwitterIcon size={32} bgStyle={twitterBgStyle} /> */}
      </TwitterShareButton>
      <FacebookShareButton url={url} aria-label="Share on Facebook">
        {/* <FacebookIcon size={32} bgStyle={facebookBgStyle} /> */}
        <FaFacebookSquare size={32} aria-hidden="true" />
      </FacebookShareButton>
      {showPinterest && (
        <PinterestShareButton
          url={url}
          media={media ? media : ''}
          description={description ? description : ''}
          aria-label="Share on Pinterest"
        >
          <FaPinterestSquare size={32} aria-hidden="true" />
          {/* <PinterestIcon size={32} bgStyle={pinterestBgStyle} /> */}
        </PinterestShareButton>
      )}
    </>
  );
};

export default SocialShare;
